var map = {
	"./favicon32.png": 5034,
	"./s_current.svg": 3078,
	"./s_end.svg": 2663,
	"./s_future.svg": 4332,
	"./seeds/82.png": 3941,
	"./svg/artifact.svg": 5411,
	"./svg/bk/artifact.svg": 1582,
	"./svg/bk/csgo.svg": 8100,
	"./svg/bk/dota2.svg": 9654,
	"./svg/bk/fn.svg": 4272,
	"./svg/bk/hs.svg": 3332,
	"./svg/bk/lol.svg": 2429,
	"./svg/bk/ow.svg": 4487,
	"./svg/bk/pubg.svg": 955,
	"./svg/bk/rl.svg": 2583,
	"./svg/bk/rs.svg": 4299,
	"./svg/bk/sc2.svg": 3971,
	"./svg/cs/bomb.svg": 4225,
	"./svg/cs/ct_win.svg": 4929,
	"./svg/cs/defuse.svg": 502,
	"./svg/cs/emptyHistory.svg": 4804,
	"./svg/cs/explode.svg": 4081,
	"./svg/cs/stopwatch.svg": 7268,
	"./svg/cs/t_win.svg": 9478,
	"./svg/csgo.svg": 9357,
	"./svg/dota-2.svg": 9497,
	"./svg/fortnite.svg": 2214,
	"./svg/hearthstone.svg": 9400,
	"./svg/logo_f.svg": 7280,
	"./svg/lol.svg": 3137,
	"./svg/overwatch.svg": 2740,
	"./svg/pubg.svg": 3710,
	"./svg/r6.svg": 4480,
	"./svg/rl.svg": 8356,
	"./svg/sc2.svg": 5031,
	"./svg/valorant.svg": 7364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4550;